module.exports = "//public.zight.com/packs/media/images/annotate/number-c227a53d1476915ce3bafb1c1361cc8c.svg";